import { isOpenedInWebview, isOpenedInWebviewFlowR2 } from '@e3dc-react/shell/Libs/webview'
import { AppVersionComparisons } from '../types'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * Returns whether the app requires an update based on its version
 *
 * @param appVersion
 * @param isIos
 * @returns
 */
export const requiresAppUpdate = (appVersion: string | null, requiredAppVersion: string): boolean => {
  if (isFlowTheme && (isOpenedInWebview() || isOpenedInWebviewFlowR2()) && !appVersion) return true
  if (!appVersion) return false

  const appVersionComparison = compareAppVersions(appVersion, requiredAppVersion)

  return appVersionComparison === AppVersionComparisons.LESS_THAN
}

/**
 * Compares app version and returns -1 if versionA < versionB,
 * 1 if currentVersion > versionB, and 0 if they are equal
 *
 * @param versionA
 * @param versionB
 * @returns number
 */
const compareAppVersions = (versionA: string, versionB: string): AppVersionComparisons => {
  const currentParts = versionA.split('.').map(Number)
  const requiredParts = versionB.split('.').map(Number)

  for (let i = 0; i < Math.max(currentParts.length, requiredParts.length); i++) {
    const currentPart = currentParts[i] || 0
    const requiredPart = requiredParts[i] || 0

    if (currentPart > requiredPart) return AppVersionComparisons.GREATER_THAN
    if (currentPart < requiredPart) return AppVersionComparisons.LESS_THAN
  }
  return AppVersionComparisons.EQUAL
}
